// extracted by mini-css-extract-plugin
export default {"NotVerified":"NotAnAdmin_NotVerified__eipzF"};